import * as React from 'react';
import { Format } from 'nomst/Stores/Utility/format';
import './compTableRow.scss';

export interface ICompTableRowProps {
    className?: string;
    label: string|React.ReactElement;
    percent?: number|string;
    amount?: number|string;
    isHourly?: boolean;
    currencyCode?: string;
    format?: Format;
}

const CompTableRow = (props: ICompTableRowProps): React.ReactElement => {
    const { label, percent, amount, format, currencyCode, isHourly, className } = props;
    const percentClass = !!percent && percent > 0 ? 'comp-table-row__data--bold' : 'comp-table-row__data--none';
    const amountClass = !amount ? 'comp-table-row__data--none' : '';

    const getFormattedPercent = () => {
        if (typeof percent === 'string') {
            return percent;
        }

        if (percent == null || !format) {
            return null;
        }

        return format.formatPercentage(percent);
    };

    const getFormattedAmount = () => {
        if (typeof amount === 'string') {
            return amount;
        }

        if (amount == null || !format) {
            return null;
        }

        return format.formatCurrencyValue(currencyCode || 'USD', amount, !!isHourly);
    };

    return (
        <div className={`comp-table-row ${className || ''}`}>
            <p className="comp-table-row__label">{label}</p>
            <p data-mf-replace-inner="***" className={`comp-table-row__data ${percentClass}`}>
                {getFormattedPercent()}
            </p>
            <p data-mf-replace-inner="***" className={`comp-table-row__data ${amountClass}`}>
                {getFormattedAmount()}
                {isHourly && <span className="comp-table-row__hourly-label">&#47;hour</span>}
            </p>
        </div>
    );
};

export default CompTableRow;
export { CompTableRow };